/**
 * Support tickets.
 *
 * Top-level rather than under `client/`, because the help page that posts these
 * (`pages/shared/help-support`) is shared and the endpoint is not
 * audience-specific — the backend keys a ticket by the organization on the
 * tenant context. It sat under `client/dashboard.js` on a /b2c URL only because
 * the consumer portal reached the page first.
 */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getExcelHeaders } from 'auth/auth';
import { api } from 'constants/constant';

export const supportAPI = createApi({
  reducerPath: 'support',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    createSupportTicket: builder.mutation({
      // multipart — the form carries attachments, so the headers helper that
      // omits an explicit Content-Type is the right one.
      query: ({ data }) => ({
        url: `b2b/support/ticket/`,
        method: 'POST',
        body: data,
        headers: getExcelHeaders(),
      }),
    }),
  }),
});

export const { useCreateSupportTicketMutation } = supportAPI;
